<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>公共日志列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>

    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="操作人：">
                  <el-input
                    v-model="form.operator_name"
                    placeholder="操作人姓名"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <br />
                <el-form-item label="日志key：">
                  <el-input
                    v-model="form.action_key"
                    placeholder="日志key"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <br />
                <el-form-item v-if="resData" label="数据来源：">
                  <el-select v-model="form.data_resource" placeholder="">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in resData.data_resource"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="时间：">
                  <el-date-picker
                    v-model="form.time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!--表格管理-->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" prop="id" label="ID">
            </el-table-column>
            <el-table-column
              align="center"
              prop="data_resource"
              label="数据来源"
            >
            </el-table-column>
            <el-table-column align="center" prop="object_id" label="操作对象id">
            </el-table-column>
            <el-table-column align="center" prop="action_mca" label="MCA">
            </el-table-column>
            <el-table-column align="center" prop="action_key" label="Key">
            </el-table-column>
            <el-table-column align="center" prop="action_content" label="Value">
            </el-table-column>
            <el-table-column align="center" prop="operator_name" label="操作人">
            </el-table-column>
            <el-table-column
              align="center"
              prop="action_value"
              label="操作备注"
            >
            </el-table-column>
            <el-table-column align="center" prop="create_date" label="操作时间">
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {},
      loading: false,
      tableLoading: false,
      url: "/erp/OperateLog/getLogList",
      status: -1,
      curPage: 1,
      filterFold: false,
    };
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code != 200) {
          this.$message.error(res.data.msg);
          return;
        }
        if (res.data.code == 200) {
          let data = res.data.data;
          res.data.data.list.map((v, k) => {
            if (v.data_resource == "ERP") {
              data.list[k].data_resource = "ERP";
            } else if (v.data_resource == "BUYER") {
              data.list[k].data_resource = "代采";
            } else if (v.data_resource == "STORAGE") {
              data.list[k].data_resource = "仓储";
            } else {
              data.list[k].data_resource = "";
            }
          });
          this.resData = res.data.data;
          return;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/CommonLog.vue